import React, { useState } from 'react';
import { Drawer, Link, LinkAsButton } from '@printdeal/ui-library';
import { useIntl } from 'react-intl';
import { Link as GatsbyLink } from 'gatsby';
import ConversationLoopLink from '../conversation-loop/ConversationLoopLink';
import {
  dispatchDataLayerEventOnSlideOutClose,
  dispatchDataLayerEventOnSlideOutOpen,
  dispatchDataLayerEventOnCustomerServiceClick,
} from './helpers/reseller-customer-care-navigation-events';

type MobileCustomerCareNavigationProps = {
  title:string,
  path:string
};

const MobileCustomerCareNavigation = ({
  title,
  path,
}: MobileCustomerCareNavigationProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const intl = useIntl();
  const handleMobileCustomerServiceLinkClickClose = () => {
    setIsOpen(false);
    dispatchDataLayerEventOnSlideOutClose();
  };

  const handleMobileCustomerServiceLinkClickOpen = () => {
    setIsOpen(true);
    dispatchDataLayerEventOnSlideOutOpen();
  };

  const handleMobileCustomerServiceClick = () => {
    setIsOpen(false);
    dispatchDataLayerEventOnCustomerServiceClick();
    dispatchDataLayerEventOnSlideOutClose();
  };

  return (
    <>
      <LinkAsButton
        onClick={handleMobileCustomerServiceLinkClickOpen}
        variant="secondary"
        iconBefore="customer-service"
      >
        <span className="pd-sr-only lg:pd-not-sr-only">{title}</span>
      </LinkAsButton>
      <Drawer
        isOpen={isOpen}
        position="right"
        onClose={handleMobileCustomerServiceLinkClickClose}
      >
        <Drawer.Header
          title={intl.formatMessage({ id: 'customercare.slideout.heading', defaultMessage: 'CustomerService' })}
          dismissLabel={intl.formatMessage({
            id: 'customercare.slideout.close',
            defaultMessage: 'Close',
          })}
          onClose={handleMobileCustomerServiceLinkClickClose}
        />
        <Drawer.Content>
          <ul>
            <li className="pd-border-b pd-px-3 pd-py-6 first:pd-pt-2">
              <Link
                as={GatsbyLink}
                to={path}
                onClick={handleMobileCustomerServiceClick}
                variant="secondary"
                iconBefore="customer-service"
              >
                {title}
              </Link>
            </li>
            <li className="pd-border-b pd-px-3 pd-py-6 first:pd-pt-2">
              <ConversationLoopLink
                handleMobileCustomerServiceLinkClickClose={handleMobileCustomerServiceLinkClickClose}
              />
            </li>
          </ul>
        </Drawer.Content>
      </Drawer>
    </>
  );
};

export default MobileCustomerCareNavigation;
